import React from 'react';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Services } from '../components/Services';
import { Leadership } from '../components/Leadership';
import { Values } from '../components/Values';
import { TargetClients } from '../components/TargetClients';
export function Home() {
  return <>
      <Hero data-id="element-317" />
      <About data-id="element-318" />
      <Services data-id="element-319" />
      <Leadership data-id="element-320" />
      <Values data-id="element-321" />
      <TargetClients data-id="element-322" />
    </>;
}